import { ReducerManager } from '@perpay-web/services/ReducerManager';
import supportToolReducer from '@perpay-web/services/supportTool';

import appUpdateReducer from './appUpdate';
import authenticationReducer from './authentication';
import dataModulesReducer from './dataModules';
import entitiesReducer from './entities/entities';
import sharedReducer from './shared/shared';
import uiReducer from './ui/ui';

const staticReducers = {
    ui: uiReducer,
    entities: entitiesReducer,
    authentication: authenticationReducer,
    shared: sharedReducer,
    appUpdate: appUpdateReducer,
    dataModules: dataModulesReducer,
    supportTool: supportToolReducer,
};

let reducerManager = null;

export function getReducerManager() {
    if (!reducerManager) {
        reducerManager = new ReducerManager(staticReducers);
    }
    return reducerManager;
}
